import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/index.vue'
import Contact from '@/pages/contact.vue'

Vue.use(VueRouter)

var router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js